module.exports = __webpack_public_path__ + "img/1543537461.7ca6b309.jpg";